import { Routes, Route, Navigate } from 'react-router-dom';
import { paths } from 'constants/pages';
import LoginPage from 'pages/login';
import HomePage from 'pages/home';
import AdminPage from 'pages/admin';
import UsersPage from './users';
import SalesTrackingPage from './salesTracking';
import PromoPages from './promo';
import BoardDocsPage from './boardDocs';
import DocumentsPage from './documents';
import MisteryPage from './mistery';
import CVPage from './cv';
import FinancePage from './finance';
import FacilityPage from './facility';
import RetailAcademyPage from './retailAcademy';
import AnalyticsPage from './analytics';
import InterviewsPage from './interviews';
import ClickCollectPage from './clickCollect';
import ForgotPassword from './forgotPassword';
import UserConfirmation from './users/subPages/main/confirmation';
import EmergencyContactsConfirm from './emergencyContactsConfirm';
import LeasingPage from './leasing';
import WebsitePage from './website';
import OldQrRedirect from './oldQrRedirect';
import VacanciesPage from './vacancies';

function Pages() {
  return (
    <Routes>
      <Route
        path={`${paths.vacancies}/:shoppingCenter`}
        element={<VacanciesPage />}
      />
      <Route
        path='/users/sign_in'
        element={<Navigate to={paths.login} replace />}
      />

      <Route path={paths.leasing} element={<LeasingPage />} />
      <Route path={paths.website} element={<WebsitePage />} />
      <Route path={paths.home} element={<HomePage />} />
      <Route path={paths.login} element={<LoginPage />} />
      <Route path={paths.forgotPassword} element={<ForgotPassword />} />
      <Route path={paths.admin} element={<AdminPage />} />
      <Route path={paths.users} element={<UsersPage />} />
      <Route path={paths.salesTracking} element={<SalesTrackingPage />} />
      <Route path={paths.promo} element={<PromoPages />} />
      <Route path={paths.boardDocs} element={<BoardDocsPage />} />
      <Route path={paths.documents} element={<DocumentsPage />} />
      <Route path={paths.mistery} element={<MisteryPage />} />
      <Route path={paths.cv} element={<CVPage />} />
      <Route path={paths.finance} element={<FinancePage />} />
      <Route path={paths.facility} element={<FacilityPage />} />
      <Route path={paths.retailAcademy} element={<RetailAcademyPage />} />
      <Route path={paths.analytics} element={<AnalyticsPage />} />
      <Route path={paths.interviews} element={<InterviewsPage />} />
      <Route path={paths.smartShopping} element={<ClickCollectPage />} />
      <Route path={paths.userConfirmation} element={<UserConfirmation />} />
      <Route
        path={paths.emergencyContactsConfirm}
        element={<EmergencyContactsConfirm />}
      />
      <Route path={paths.companiesForQr} element={<OldQrRedirect />} />
    </Routes>
  );
}

export default Pages;
